module.exports = __webpack_public_path__ + "img/3-1.a49d9437.png";